import {FACTION_UNIT_SOUNDS} from '../../configs/factionUnitSounds';
import {getRandomElement} from '../other/getRandomElement';

/**
 * Свой звук отряда фракции — тот, что подходит его особому образу (волки и
 * кабаны орков вместо лошадей, писк крысолюдов вместо человеческого клича).
 *
 * Звучит только у отряда, нарисованного особым образом фракции
 * (hasFactionSkin — то же правило, что у картинки на поле, см.
 * checkIfUnitHasFactionSkin): отряд общим силуэтом звучит общим звуком.
 *
 * Если для фракции, типа отряда или события своего звука нет — null: тогда
 * звучит общий звук отряда.
 *
 * @param {Object} params
 * @param {string|null|undefined} params.factionId — фракция отряда
 * @param {string} params.unitType — тип отряда (UNIT_TYPES.*.id)
 * @param {'select'|'move'} params.kind — выбор и найм отряда или его ход
 * @param {boolean} params.hasFactionSkin — отряд нарисован образом фракции
 * @returns {string|null} имя отложенного звука (configs/deferredSounds)
 */
export const resolveFactionUnitSoundId = ({factionId, unitType, kind, hasFactionSkin}) => {
  if (!hasFactionSkin || !factionId) {
    return null;
  }
  const soundIds = FACTION_UNIT_SOUNDS[factionId]?.[unitType]?.[kind];
  if (!soundIds) {
    return null;
  }
  if (!Array.isArray(soundIds)) {
    return soundIds;
  }
  return soundIds.length ? getRandomElement(soundIds) : null;
};
